import React from "react";
import { Container } from "react-bootstrap";

import { motion } from "framer-motion";

import { slideIn } from "../utils/motionVariants";
import SlideInContainer from "./AppComponents/SlideInContainer";

const Skills = () => {
  return (
    <div id="skills">
      <Container className="text-light">
        <h3 className="text-accent">Skills</h3>
        <hr />

        <SlideInContainer
          duration={1}
          delay={0.2}
        >
          <Container as="h3">FrontEnd</Container>

          <br />

          <p>🔹ReactJS</p>
          <p>🔹NextJS</p>
          <p>🔹Javascript</p>
          <p>🔹TailwindCSS</p>
          <p>🔹React Three Fiber</p>

          <br />
        </SlideInContainer>

        <SlideInContainer
          duration={1}
          delay={0.4}
        >
          <Container as="h3">BackEnd</Container>

          <br />

          <p>🔹NodeJS Core Modules</p>
          <p>🔹ExpressJS</p>
          <p>🔹RESTful API</p>
          <p>🔹GraphQL API</p>
          <p>
            🔹Model View Controller (MVC) Pattern
          </p>

          <br />
        </SlideInContainer>

        <SlideInContainer
          duration={1}
          delay={0.6}
        >
          <Container as="h3">Databases</Container>

          <br />

          <p>🔹MySQL</p>
          <p>🔹Postgre SQL</p>
          <p>🔹MongoDB</p>

          <br />
        </SlideInContainer>

        <SlideInContainer
          duration={1}
          delay={0.8}
        >
          <Container as="h3">
            Essentials
          </Container>

          <br />

          <p>
            🔹Basics of Linux Command Line
            Interface (CLI)
          </p>
          <p>🔹Basics of GIT</p>
          <p>🔹Node Package Manager (NPM)</p>
          <p>🔹Basics of Docker</p>

          <br />
        </SlideInContainer>

        <SlideInContainer
          duration={1}
          delay={0.9}
        >
          <Container as="h3"> Others </Container>

          <br />
          <p>
            🔹API Testing with JEST and Supertest
          </p>
          <p>
            🔹Validating User Inputs Using JOI
          </p>
          <p>
            🔹Authentication and Authorization
            with Json Web Token (JWT)
          </p>
          <p>🔹Hashing Password with Bcrypt </p>
          <p>
            🔹Using PM2 for managing servers and
            creating clusters{" "}
          </p>

          <br />
        </SlideInContainer>
      </Container>
    </div>
  );
};

export default Skills;
